import React from 'react'
import { makeStyles } from '@material-ui/core'
import DropzoneComponent from 'react-dropzone-component'
import { useAuth } from '../context/useFetch'

const useStyles = makeStyles((theme) => ({
  DropzoneFormControl: {
    position: 'relative',
    '& .dropzone': {
      zIndex: '10',
      position: 'relative',
      backgroundColor: 'transparent !important',
      padding: theme.spacing(2),
      border: 'none',
      '&::before': {
        height: '48px',
        backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxZW0iIGhlaWdodD0iMWVtIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGw9IiMyNzI3MmEiIGQ9Ik0xMSAyMEg2LjVxLTIuMjc1IDAtMy44ODctMS41NzVRMSAxNi44NSAxIDE0LjU3NXEwLTEuOTUgMS4xNzUtMy40NzVRMy4zNSA5LjU3NSA1LjI1IDkuMTVxLjYyNS0yLjMgMi41LTMuNzI1UTkuNjI1IDQgMTIgNHEyLjkyNSAwIDQuOTYyIDIuMDM3UTE5IDguMDc1IDE5IDExcTEuNzI1LjIgMi44NjMgMS40ODdRMjMgMTMuNzc1IDIzIDE1LjVxMCAxLjg3NS0xLjMxMiAzLjE4OFEyMC4zNzUgMjAgMTguNSAyMEgxM3YtNy4xNWwxLjYgMS41NUwxNiAxM2wtNC00bC00IDRsMS40IDEuNGwxLjYtMS41NVoiLz48L3N2Zz4=")'
      },
      '& .dz-message': {
        color: theme.palette.text.primary,
        fontFamily: 'Poppins, Almarai',
        fontSize: '16px',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0)
      },
      '& .dz-preview': {
        margin: theme.spacing(1),
        '& .dz-image': {
          borderRadius: '8px'
        },
        '& .dz-details': {
          color: theme.palette.text.primary,
          fontSize: '12px',
          padding: theme.spacing(2),
          '& .dz-size': {
            marginBottom: theme.spacing(0)
          },
          '& .dz-size span, & .dz-filename span': {
            backgroundColor: 'transparent',
            padding: theme.spacing(0)
          }
        },
        '& .dz-progress': {
          background: theme.palette.background.secondary,
          marginTop: theme.spacing(-0.5),
          height: '8px',
          borderRadius: '4px',
          '& .dz-upload': {
            background: theme.palette.primary.main
          }
        }
      }
    },
    '& .dashed': {
      position: 'absolute',
      top: '40.5px',
      left: '16px',
      width: 'calc(100% - 32px)',
      height: 'calc(100% - 52.5px)',
      fill: 'transparent',
      '& rect': {
        stroke: theme.palette.text.primary,
        strokeDasharray: '10 5 10',
        transition: `stroke-dasharray 1s ${theme.transitions.easing.easeInOut}`
      }
    },
    '& .dz-drag-hover + .dashed': {
      '& rect': {
        strokeDasharray: '10 0'
      }
    }
  }
}))

export const DropzoneDocs = (props) => {
  const auth = useAuth()
  const classes = useStyles()

  return (
    <div className={`${classes.DropzoneFormControl} likeMuiFormControl`}>
      <span className="likeLabel">
        {props.likeLabel}
      </span>
      <DropzoneComponent
        config={{
          postUrl: props.postUrl
        }}
        djsConfig={{
          dictDefaultMessage: props.dictDefaultMessage,
          headers: auth.authHeaders(),
          acceptedFiles: props.acceptedFiles,
          paramName: props.paramName,
          params: props.params
        }}
        eventHandlers={props.eventHandlers}
      />
      <svg className="dashed">
        <rect width="100%" height="100%" rx="4" />
      </svg>
    </div>
  )
}
